// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "人工智能与计算思维",
      "tec": "赵越",
      "week": "6-16周",
      "add": "教学楼D座518机械AISEC"
    },
    {
      "sub": "大学英语（一）",
      "tec": "王立野",
      "week": "6-17周",
      "add": "实训楼E座302语音室"
    },
    {
      "sub": "体育（一）",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[05-06节]）"
    },
    0,
    {
      "sub": "军事理论",
      "tec": "韩峰",
      "week": "6-12,14-15周",
      "add": "教学楼C座307教务"
    }
  ],
  "2": [
    {
      "sub": "思想道德与法治",
      "tec": "梁春娥",
      "week": "6-12,14-18周",
      "add": "教学楼A座426机械"
    },
    {
      "sub": "高等数学（一）",
      "tec": "王娜",
      "week": "6-17周",
      "add": "教学楼D座517机械AISEC"
    },
    0,
    0,
    {
      "sub": "形势与政策",
      "tec": "杨淑一",
      "week": "6-9周",
      "add": "教学楼C座306教务"
    }
  ],
  "3": [
    0,
    {
      "sub": "高等数学（一）",
      "tec": "王娜",
      "week": "6-17周",
      "add": "教学楼D座517机械AISEC"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "大学英语（一）",
      "tec": "王立野",
      "week": "6-17周",
      "add": "实训楼F座203自控"
    },
    {
      "sub": "思想道德与法治",
      "tec": "梁春娥",
      "week": "6-12,14-18周",
      "add": "教学楼A座422机械"
    },
    {
      "sub": "人工智能与计算思维",
      "tec": "赵越",
      "week": "6-15单周",
      "add": "教学楼D座517机械AISEC"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "高等数学（一）",
      "tec": "王娜",
      "week": "6-17周",
      "add": "教学楼D座517机械AISEC"
    },
    0,
    {
      "sub": "明辨性思维",
      "tec": "赵勤",
      "week": "6-13周",
      "add": "教学楼D座419文法"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
